// extracted by mini-css-extract-plugin
module.exports = {"row":"dece2e673c--row--jV8gd"};